import api from './api';

export const getExpenses = () => api.get('/expenses');
export const createExpense = (data) => api.post('/expenses', data);
export const updateExpense = (id, data) => api.put(`/expenses/${id}`, data);
export const deleteExpense = (id) => api.delete(`/expenses/${id}`);
export const bulkDeleteExpenses = (ids) => api.post('/expenses/bulk-delete', { ids });

// Paid-by / split-payment + out-of-pocket reimbursement tracking
export const getExpensePayers = () => api.get('/expenses/payers');
export const getOutOfPocketPayments = () => api.get('/expenses/out-of-pocket');
export const setPaymentReimbursed = (paymentId, reimbursed) =>
    api.patch(`/expense-payments/${paymentId}/reimburse`, { reimbursed });
export const bulkSetPaymentsReimbursed = (ids, reimbursed) =>
    api.patch('/expense-payments/bulk-reimburse', { ids, reimbursed });

// Per-user Expenses-table column visibility ("Columns" view option) - persisted
// server-side (users.db) so it's consistent across browsers/devices, not localStorage.
export const getExpenseColumnPrefs = () => api.get('/expenses/column-prefs');
export const updateExpenseColumnPrefs = (columns) => api.put('/expenses/column-prefs', { columns });

// Best-effort BTW-summary extraction from an attached PDF, to pre-fill line
// items. fileBase64 is a data URL (same encoding FileReader.readAsDataURL
// already produces for the attachment upload itself).
export const extractExpensePdfLineItems = (fileBase64) => api.post('/expenses/extract-pdf', { file_base64: fileBase64 });

// Receipt photo -> suggested fields via OCR (POST /expenses/extract-receipt). Read-only on the server: nothing is
// saved. The server allows up to 30 s for the OCR itself (plus up to 20 s waiting for the single OCR slot).
export const extractExpenseReceipt = (fileBase64) =>
    api.post('/expenses/extract-receipt', { file_base64: fileBase64 }, { timeout: 70000 });

// Fetch an expense attachment as a binary blob (token is added by the interceptor).
// attachmentUrl is the relative path returned by the API, e.g. /api/expenses/files/abc.pdf
export const getExpenseFileBlob = (attachmentUrl) => {
    // Strip the leading /api since the axios instance already has baseURL=/api
    const path = attachmentUrl.startsWith('/api') ? attachmentUrl.slice(4) : attachmentUrl;
    return api.get(path, { responseType: 'blob' });
};


// Accounting side of an expense (supplier link, cost category, BTW treatment, invoice number, confidence, confirmed flag).
// Stored in accounting_expense only: the expense itself is never changed by these calls.
export const getExpensesAccounting = () => api.get('/expenses/accounting');
export const getExpenseAccountingOptions = () => api.get('/expenses/accounting-options');
export const putExpenseAccounting = (id, data) => api.put(`/expenses/${id}/accounting`, data);
